import React from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'
import AuthContent from '@/pages/auth/components/AuthContent'
import SelectBoxApi from '@/components/layout/SelectBoxApi'
import { useRedirectAuth } from '@/pages/legacy/hooks/useRedirectAuth'

// LOGISPRD-11076: 인증 화면은 Okta 리뉴얼 플로우 하나뿐이라 배경/footer 분기가 사라졌다.
// 리뉴얼 화면이 portal 로 흰 배경 전체를 덮으므로 배경이미지를 깔지 않고(전환 순간 깜빡임 방지),
// fixed footer 가 portal 위로 비치지 않도록 footer 도 렌더하지 않는다.
function AuthWrapper() {
  useRedirectAuth()

  return (
    <AuthWrapperWithBg>
      <AuthContent>
        <Outlet />
        <SelectBoxApi />
      </AuthContent>
    </AuthWrapperWithBg>
  )
}

const AuthWrapperWithBg = styled.div`
  background: #fff;
  padding-top: 62px;
  padding-bottom: 42px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

export default AuthWrapper
